import { render, staticRenderFns } from "./CreateTareaModal.vue?vue&type=template&id=3e711454&scoped=true"
import script from "./CreateTareaModal.vue?vue&type=script&lang=js"
export * from "./CreateTareaModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTareaModal.vue?vue&type=style&index=0&id=3e711454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e711454",
  null
  
)

export default component.exports